import { List } from 'immutable';

import { NotFoundError } from '../lib/APIClient';
import { resolveAll } from '../helpers/LinkMapper';
import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';
import StoredPaymentCard from '../records/customer/StoredPaymentCard';

function makeStoredCard (userId) {
    return function (json) {
        json.link = `/customers/${userId}/saved-card/${json.id}`;
        return StoredPaymentCard.fromJSON(json);
    };
}

const PaymentCardService = {

    async getAll (user) {
        if (!user) {
            return false;
        }
        try {
            const userId = user.id;
            const endpoint = `/v2/customers/${userId}/saved-cards`;
            const response = await AuthenticatedAPIClient.get(endpoint);
            return resolveAll(response.cards).with(makeStoredCard(userId));
        } catch (error) {
            if (!(error instanceof NotFoundError)) { throw error; }
            return new List();
        }
    },

    async delete (user, card) {
        /*
            Pay360 hosted cards have a card token, and are deleted differently to 'regular' cards.

            we need to support both while transitioning from 'regular' cards to hosted card payments as the user may
            have a mix of both card types in their account.
        */
        const endpoint = card.cardToken ? `/v2/customers/${user.id}/saved-cards/${card.cardToken}` : `/customers/${user.id}/saved-cards/${card.id}`;
        await AuthenticatedAPIClient.delete(endpoint);
    }

};


export default PaymentCardService;



// WEBPACK FOOTER //
// ./src/services/PaymentCardService.js